/* Routes. Five screens (the fifth, /accuracy, is read-only reporting), one product — there is no `?ui=` variant switch and
 * there will not be one: two versions of a screen means every change has to be
 * made twice and one of them is always forgotten.
 *
 * Everything except /login sits behind RequireAuth. That is a DEMO GATE, not
 * security — see lib/auth.ts for why, and for what has to change when it needs
 * to be real.
 */

import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router";
import type { ReactNode } from "react";
import { Queue } from "./pages/Queue";
import { Workspace } from "./pages/Workspace";
import { QaReview } from "./pages/QaReview";
import { Accuracy } from "./pages/Accuracy";
import { Login } from "./pages/Login";
import { ToastHost } from "./components/ui";
import { isSignedIn } from "./lib/auth";

function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!isSignedIn()) {
    // Carry where they were going, so signing in resumes that instead of
    // always landing on the queue. A deep link to a job survives the gate.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastHost>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RequireAuth><Queue /></RequireAuth>} />
          <Route path="/job/:id" element={<RequireAuth><Workspace /></RequireAuth>} />
          <Route path="/qa/:id" element={<RequireAuth><QaReview /></RequireAuth>} />
          <Route path="/accuracy" element={<RequireAuth><Accuracy /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ToastHost>
    </BrowserRouter>
  );
}
